<template>
  <div>
    <b-container class="text-left">
      <h1 class="mt-2 mb-2">Egyéni Vállalkozás hozzáadása</h1>

      <b-row>
        <b-col class="mt-4 mb-4 mr-3" cols="12" lg="8" xl="8">
          <h2>Már csak egy lépés van hátra a regisztráció befejezéséig!</h2>
          <p class="mt-4 text-justify text-gray-04">
            Az Ön által kiválasztott és képviselt egyéni vállalkozást összekötjük a profiljával, így a későbbiekben is
            tájékozódhat az aktuális fejlesztési lehetőségekről.
          </p>
        </b-col>
      </b-row>

      <div class="mt-2">
        <b-row>
          <b-col cols="12" xl="12">
            <b-form>
              <div class="bg-color-lightblue rounded p-5">
                <h2 v-if="selectedSoleProprietorship" class="mb-3">
                  {{ getSoleProprietorshipInformation(selectedSoleProprietorship) }}
                </h2>
                <label for="position">Egyéni vállalkozásban betöltött tisztség</label>
                <b-form-group>
                  <b-form-select v-model="selectedPosition" :options="positionOptions" id="position" class="w-75">
                    <template #first>
                      <b-form-select-option :value="null" disabled
                        >Egyéni vállalkozásban betöltött tisztség</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="statement"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mt-3"
                  >
                    Elfogadom a
                    <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                      Felhasználási feltételeket
                    </a>
                  </b-form-checkbox>
                </b-form-group>
                <b-button
                  class="mt-4"
                  type="submit"
                  variant="primary"
                  @click.prevent="onConfirmationSubmission"
                  :disabled="isLoading"
                >
                  <b-spinner small v-if="isLoading"></b-spinner>
                  <span class="sr-only" v-if="isLoading">Betöltés...</span>
                  <span v-if="!isLoading">Hozzáadás</span>
                </b-button>
              </div>
            </b-form>
            <br />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      selectedPosition: null,
      positionOptions: [
        { value: 'SOLE_PROPRIETORSHIP', text: 'Vállalkozó' },
        { value: 'ACCOUNTANT', text: 'Könyvelő' },
        { value: 'APPLICATION_WRITER', text: 'Pályázatíró' },
        { value: 'CONSULTANT', text: 'Tanácsadó' }
      ],
      statement: 'not_accepted'
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'selectedSoleProprietorship', 'getUser', 'userSoleProprietorships'])
  },
  methods: {
    async onConfirmationSubmission() {
      if (this.statement == 'not_accepted') {
        this.$store.dispatch('notify', {
          newNotification: { type: 'info', message: 'A felhasználási feltételek elfogadása kötelező.' }
        })
      } else {
        if (this.selectedPosition) {
          const userSoleProprietorshipData = {
            soleProprietorshipId: this.selectedSoleProprietorship.flaggerId,
            position: this.selectedPosition
          }

          await this.$store.dispatch('createUserSoleProprietorship', userSoleProprietorshipData)

          const getParams = {}
          await this.$store.dispatch('getUserSoleProprietorships', getParams)
          const createdSoleProprietorship = this.userSoleProprietorships.filter(function(userSoleProprietorship) {
            return userSoleProprietorship.soleProprietorshipId === userSoleProprietorshipData.soleProprietorshipId
          })

          this.$store.commit('setSelectedSoleProprietorship', createdSoleProprietorship[0].soleProprietorshipData)

          // const getSoleProprietorshipQueryParams = {
          //   value: createdSoleProprietorship[0].soleProprietorshipData.flaggerId
          // }

          // await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)

          // this.$store.commit('setSelectedSoleProprietorship', createdSoleProprietorship[0])

          // TODO
          // if (this.$route.query.redir == 'kkv-result') {
          //   this.$router.push({ path: this.$route.query.redir, query: { soleProprietorshipId: this.$route.query.soleProprietorshipId } })
          //   return
          // }

          this.$router.push({
            path: '/sole-proprietorship-offers-private',
            query: { soleProprietorshipId: userSoleProprietorshipData.soleProprietorshipId }
          })
        } else {
          this.$store.dispatch('notify', {
            newNotification: {
              type: 'info',
              message: 'Az egyéni vállalkozáson belül betöltött tisztség kiválasztása kötelező.'
            }
          })
        }
      }
    },
    filteredUserSoleProprietorship(selectedId) {
      return this.userSoleProprietorships.filter(function(soleProprietorship) {
        return soleProprietorship.soleProprietorshipId === selectedId
      })
    },
    getSoleProprietorshipInformation(information) {
      const name = information?.name
        .split(' ')
        .map(name => {
          const lowerCaseName = name.toLowerCase()
          return lowerCaseName.charAt(0).toUpperCase() + lowerCaseName.slice(1)
        })
        .join(' ')

      const postCode = information?.address[0]?.address.slice(0, 4)

      let location = information?.address[0]?.address
        .slice(4)
        .split(',')[0]
        .toLowerCase()

      location = location.charAt(1).toUpperCase() + location.slice(2)

      return `${name} - ${information.tax_number} - ${location}, ${postCode}`
    }
  },
  mounted() {
    const soleProprietorshipId = this.$route.query.soleProprietorshipId
    if (this.filteredUserSoleProprietorship(soleProprietorshipId).length != 0) {
      if (this.$route.query.redir == 'kkv-result') {
        this.$router.push({
          path: 'kkv-result',
          query: { soleProprietorshipId: this.$route.query.soleProprietorshipId }
        })
        return
      }
    }
  }
}
</script>

<style scoped>
.btn {
  min-height: 48px;
  width: 235px;
}
</style>
